import React from 'react';
import { LanguageCodeEnum } from '../../common/enums/common.enum';
import { Box, MenuItem, Select, Typography } from '@mui/material';
import { languageMeta } from '../../common/constants/language.constants';
import { ReactComponent as CheckIcon } from '../../assets/check-icon.svg';
import { LanguageCounterBadgeBox } from './LanguageSelector.styles';

interface LanguageSelectorProps {
  value: LanguageCodeEnum;
  onChange: (lang: LanguageCodeEnum) => void;
  items: { title: Record<string, string> }[];
}
const LanguageSelector: React.FC<LanguageSelectorProps> = ({ value, onChange, items }) => {
  const getFilledCountForLang = (lang: LanguageCodeEnum) => {
    return items.filter(item => item?.title?.[lang]?.trim()).length;
  };

  return (
    <Select
      size="small"
      value={value}
      onChange={e => onChange(e.target.value as LanguageCodeEnum)}
      renderValue={selected => {
        const lang = selected as LanguageCodeEnum;
        const { shortLabel, Flag } = languageMeta[lang];
        return (
          <Box display="flex" alignItems="center" gap={1}>
            <Flag style={{ width: 27, height: 20 }} />
            <Typography variant="body2">{shortLabel}</Typography>
            <LanguageCounterBadgeBox>
              {getFilledCountForLang(value)}/{items.length}
            </LanguageCounterBadgeBox>
          </Box>
        );
      }}
    >
      {Object.entries(languageMeta)
        .filter(([langCode]) => langCode !== LanguageCodeEnum.ENG)
        .map(([langCode, { label, Flag }]) => {
          const lang = langCode as LanguageCodeEnum;

          const translated = getFilledCountForLang(lang);
          const isTranslated = translated === items.length;
          return (
            <MenuItem key={langCode} value={langCode} sx={{ py: 1.5 }}>
              <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
                <Box display="flex" alignItems="center" gap={2} minWidth="212px">
                  <Flag style={{ width: 27, height: 20 }} />
                  <Box display="flex" flexDirection="column" lineHeight={1.2}>
                    <Typography variant="body2" sx={{ whiteSpace: 'nowrap', minWidth: 80, color: 'text.primary' }}>
                      {label}
                    </Typography>
                    <Typography variant="caption" sx={{ color: isTranslated ? '#6B8551' : '#626262' }}>
                      {translated}/{items.length} translated
                    </Typography>
                  </Box>
                </Box>

                {value === lang && <CheckIcon />}
              </Box>
            </MenuItem>
          );
        })}
    </Select>
  );
};
export default LanguageSelector;
